import React, { useState } from 'react';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';

const FieldCurvesTabs = ({ children }) => {
  const tabsTitles = ['field-average-editable', 'view-by-zone'].map(getMessage);
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className='field-curves-tabs'>
      <ul>
        {tabsTitles.map((tabTitle, index) => (
          <li
            className={activeIndex === index ? 'active' : ''}
            key={index}
            onClick={() => setActiveIndex(index)}
          >
            {tabTitle}
          </li>
        ))}
      </ul>
      {children
        && <div>
          {children[activeIndex]}
        </div>
      }
    </div>
  );
};

FieldCurvesTabs.propTypes = {
  children: propTypes.arrayOf(propTypes.node)
};

export default FieldCurvesTabs;
